document.addEventListener('DOMContentLoaded', () => {

    const background = document.querySelector('[data-gauge-illustration="background"]')

    if (background) {

        const observer = new MutationObserver(toggleScrollLock);

        observer.observe(document.body, { attributes: true, attributeFilter: ['style'] });

        toggleScrollLock();

        const handle = document.querySelector('[data-gauge-illustration="handle"]')

        const container = background.closest('.gauge-animation')

        const reverse = handle.dataset.reverse ? true : false

        const start = parseInt(handle.dataset.start)

        const end = parseInt(handle.dataset.end)

        let isLocked = false

        let rotation = parseInt(handle.dataset.start)

        let rotationActive = false;

        let lastScrollY = window.scrollY;

        let scrollDirection = null;

        let oldPercent

        // swipe handle 

        let startY = 0;

        let endY = 0;

        let lockedDown = false

        let lastScrollTop = window.pageYOffset;

        window.addEventListener('wheel', (e) => {

            if (!isLocked) return;

            e.preventDefault();

            const delta = e.deltaY > 0 ? 5 : -5;

            updateRotation(delta);

        }, { passive: false });

        // Optional: touch support
        let lastTouchY = null;

        window.addEventListener('touchstart', (e) => {
            lastTouchY = e.touches[0].clientY;
            startY = lastTouchY
        });

        window.addEventListener('touchmove', (e) => {

            if (!isLocked) return;

            e.preventDefault();

            const currentY = e.touches[0].clientY;

            const deltaY = lastTouchY - currentY;

            const delta = deltaY > 0 ? 1 : -1

            checkScrollLockTrigger();

            updateRotation(delta, true);

            lastTouchY = currentY;
            
        }, { passive: false });


        window.addEventListener('touchend', function (e) {
            endY = e.changedTouches[0].clientY;
            handleSwipe();
        });

        window.addEventListener('scroll', () => {

            scrollDirection = window.scrollY > lastScrollY ? 'down' : 'up';

            lastScrollY = window.scrollY;

            checkScrollLockTrigger();

            const currentScrollTop = window.pageYOffset;

            // Detect sudden jump to top
            if (lastScrollTop > 100 && currentScrollTop === 0) {

                start = parseInt(handle.dataset.start)

                end = parseInt(handle.dataset.end)

                isLocked = false

                rotation = parseInt(handle.dataset.start)

                rotationActive = false;

                lastScrollY = 0;

                scrollDirection = null;

                // swipe handle 

                startY = 0;

                endY = 0;

                lockedDown = false


            }

            lastScrollTop = currentScrollTop;

        });

        function handleSwipe() {

            const diffY = startY - endY;

            scrollDirection = diffY > 0 ? 'down' : 'up'

            checkScrollLockTrigger()
        }


        function toggleScrollLock() {
            isLocked ? document.body.classList.add('hidden-gauge') : document.body.classList.remove('hidden-gauge')
        }

        function checkScrollLockTrigger() {

            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        const menuHeight = document.getElementById('header-main-menu').offsetHeight


            const isDesktop = window.innerWidth >= 992

            const element = isDesktop ? container : handle.closest('.gauge-animation-inner-illustration')

            const offsetTop = element.offsetTop

            if (scrollDirection === 'down' && isElementTopAtOrAboveViewport(element) && lockedDown === false && rotation >= start) {

                isLocked = true;

                rotationActive = true;

                document.body.style.overflow = rotation !== start ? 'hidden' : 'auto'

                if (scrollTop > offsetTop) {

                    window.scrollTo({
                        top: offsetTop + menuHeight,
                        behavior: 'smooth',
                    });
    
                }

            }

            if (scrollDirection === 'up' && isElementBelowViewport(element) && lockedDown === true && rotation <= end) {

                isLocked = true;

                rotationActive = true;

                document.body.style.overflow = rotation !== end ? 'hidden' : 'auto'

                if (scrollTop > offsetTop) {

                    window.scrollTo({
                        top: offsetTop + menuHeight,
                        behavior: 'smooth',
                    });
    
                }

            }

        }

        function isElementTopAtOrAboveViewport(el) {
            const rect = el.getBoundingClientRect();
            return rect.top <= 0 && rect.bottom > 0;
        }
    
    
        function isElementBelowViewport(el) {
            const rect = el.getBoundingClientRect();
            const bottom = rect.bottom - rect.height
            return rect.top >= 0 && bottom >= 0
        }

        function setProgressText(percent, mobile) {

            const el = document.querySelector('#volume-db')

            const max = el.dataset['value'] ?? 0

            const calculated = max / 100 * percent

            const unit = el.dataset['unit'] ?? ''

            el.textContent = oldPercent < percent ?
                '-' + Math.ceil(Math.min((mobile ? (calculated ) : calculated), max)) + ' ' + unit :
                '-' + Math.floor(Math.max((mobile ? (calculated ) : calculated), 0)) + ' ' + unit

            oldPercent = percent
        }

        function updateRotation(delta, mobile = false) {

            if (!rotationActive) return;

            if (mobile) {
                delta = delta * 50
            }
            
            rotation = reverse ? (rotation -= delta) : (rotation += delta)

            if( reverse ) {

                if(rotation >= start) {
                    rotation = start;
                } else if (rotation <= end) {
                    rotation = end;
                }

            } else {

                if(rotation >= end) {
                    rotation = end;
                } else if (rotation <= start) {
                    rotation = start;
                }
            }

            const min = parseInt(handle.dataset.start);

            const max = end;

            const percent = ((rotation - min) / (max - min)) * 100;

            setProgressText(percent, mobile);

            if (isLocked) {
                handle.style.transform = `translate(-50%, -50%) rotate(${rotation}deg)`;
            }

            const conditionMax = reverse ? (rotation <= max) : (rotation >= max)

            const conditionMin = reverse ? (rotation >= min) : (rotation <= min)

            if (conditionMax) {
                rotation = max;
                isLocked = false;
                lockedDown = true
                document.body.style.overflow = 'auto';
                container.classList.remove('in-view')
                return;
            }

            if (conditionMin) {
                rotation = min;
                isLocked = false;
                lockedDown = false
                document.body.style.overflow = 'auto';
                container.classList.remove('in-view')
                return;
            }

            isLocked = true;

            container.classList.add('in-view')

            document.body.style.overflow = 'hidden';


        }

    }

})